import api from './api';

export const activoService = {
  async getActivos(params = {}) {
    const response = await api.get('/activos', { params });
    return response.data;
  },
  async getActivo(id) {
    const response = await api.get(`/activos/items/${id}`);
    return response.data;
  },
  async createActivo(data) {
    const response = await api.post('/activos', data);
    return response.data;
  },
  async importInitialActivos(data) {
    const response = await api.post('/activos/import-initial', data);
    return response.data;
  },
  async createInitialActivo(data) {
    const response = await api.post('/activos/import-initial', { items: [data] });
    return response.data;
  },
  async updateActivo(id, data) {
    const response = await api.put(`/activos/items/${id}`, data);
    return response.data;
  },
  async deleteActivo(id) {
    const response = await api.delete(`/activos/items/${id}`);
    return response.data;
  },
  async startActivities(id, activityStartDate, usefulLifeYears) {
    const response = await api.post(`/activos/items/${id}/start-activities`, {
      activity_start_date: activityStartDate,
      useful_life_years: usefulLifeYears,
    });
    return response.data;
  },
  async updateActivityStartDate(id, activityStartDate, usefulLifeYears) {
    const response = await api.patch(`/activos/items/${id}/activity-start-date`, {
      activity_start_date: activityStartDate,
      useful_life_years: usefulLifeYears,
    });
    return response.data;
  },
  async updateArea(id, areaId) {
    const response = await api.patch(`/activos/items/${id}/area`, {
      area_id: areaId,
    });
    return response.data;
  },
  async lookupMachinery(code) {
    const response = await api.get('/activos/machinery-lookup', {
      params: { code },
    });
    return response.data;
  },
  async linkMachinery(id, data) {
    const response = await api.patch(`/activos/items/${id}/machinery`, data);
    return response.data;
  },
  async previewRetireActivo(id, retiredAt) {
    const response = await api.get(`/activos/items/${id}/retire-preview`, {
      params: { retired_at: retiredAt },
    });
    return response.data;
  },
  async retireActivo(id, data) {
    const response = await api.post(`/activos/items/${id}/retire`, data);
    return response.data;
  },
  async getFormData(params = {}) {
    const response = await api.get('/activos/form-data', { params });
    return response.data;
  },
};

export default activoService;
